<template>
  <div>
    <el-button class="btn" type="primary" :loading="loading" @click="connectMetaMask()">
      {{ btnText }}
    </el-button>
  </div>
</template>

<script>
import MetaMaskOnboarding from '@metamask/onboarding'
import metaMask from './metaMask.js'
import {
  ensureTargetChain,
  requestWalletConnection
} from '@/utils/walletRuntime'

export default {
  name: 'MmLogin',
  data() {
    return {
      btnText: 'Connect MetaMask',
      isInstall: true,
      isConnect: false,
      loading: false,
      account: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.isInstall = metaMask.isMetaMaskInstalled()
      if (this.isInstall) {
        this.btnText = 'Connect Wallet'
      } else {
        this.btnText = 'Install MetaMask'
      }
    },
    async connectMetaMask() {
      if (!this.isInstall) {
        this.btnText = 'Onboarding in progress'
        const onboarding = new MetaMaskOnboarding()
        onboarding.startOnboarding()
      } else {
        this.loading = true
        this.btnText = 'Connect Wallet'
        try {
          await ensureTargetChain()
          await this.onClickConnect()
        } catch (error) {
          this.$message.error(
            error && error.message ? error.message : 'Failed to join the network'
          )
        } finally {
          this.loading = false
        }
      }
    },
    async onClickConnect() {
      const account = await requestWalletConnection()
      this.account = account
      this.btnText = 'Connected'
      this.isConnect = true
      this.$emit('success', account)
    }
  }
}
</script>

<style lang="scss" scoped>
.mm-logo {
  margin-right: 0.1rem;
}
.btn{
  width: 2.56rem;
  height: 0.56rem;
  background: linear-gradient(90deg, #225BFC 0%, #1C50DE 100%);
  border-radius: 0.04rem;
  font-size: 0.18rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  margin-top: 0.64rem;
  cursor: pointer;
}
</style>
